import React, { useCallback, useEffect, useState, useRef } from 'react';
import {
  DateField,
  ListContextProvider,
  useListContext,
  ListBase,
  ListToolbar,
  Pagination,
  Datagrid,
  useRefresh,
  Title,
  TextField,
} from 'react-admin';

import { Divider, Tabs, Tab, Card, makeStyles } from '@material-ui/core';
import CancelIcon from '@material-ui/icons/Cancel';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import DetailsIcon from '@material-ui/icons/Details';
import PrintIcon from '@material-ui/icons/Print';
import { useSnackbar } from 'notistack';

import ActionsList from '../../Components/ReactAdmin/ActionsList';
import ActionsField from '../../Components/ReactAdmin/Fields/ActionsField';
import Textofield from '../../Components/ReactAdmin/Fields/TextoField';
import { ProtegerPagina } from '../../layout/VerificaPermissaoPage';
import { imprimirTroco } from '../../services/impressora';
import { stylesMalote } from '../../utils';
import { PERMISSAO_TELA_SANGRIAS_LISTAR } from '../../utils/dadosTelas';
import ValorTransferenciaField from '../Transacoes/Fields/ValorTransferenciaField';
import DialogoChangeStatus from './DialogoChangeStatus';
import DialogoDeletar from './DialogoDeletar';
import DialogoLixeira from './DialogoLixeira2';
import DialogoShowSangria from './DialogoShowSangria';
//import ActionsField from './Fields/ActionsField';
import CodigoField from './Fields/CodigoField';
import ContaField from './Fields/ContaField';
import StatusField from './Fields/StatusField';
import Filter from './Filter';

const useStylesDatagrid = makeStyles((theme) => stylesMalote);

const tabs = [
  { id: 'nao_conferido', name: 'Não Utilizadas' },
  { id: 'conferido', name: 'Utilizadas' },
];
//
const MyList = ({ ...props }) => {
  const listContext = useListContext();
  const { ids, filterValues, setFilters, displayedFilters } = listContext;
  const [confirmados, setConfirmados] = useState([]);
  const [cancelados, setCancelados] = useState([]);
  const refresh = useRefresh();
  const classes = useStylesDatagrid();
  const refDialogoChangeStatus = useRef(null);
  const refDialogoShowSangria = useRef(null);
  const refDialogoDeletar = useRef(null);
  const refDialogoLixeira = useRef(null);

  function changeStatus(record) {
    if (refDialogoChangeStatus.current)
      refDialogoChangeStatus.current.handleOpen(record.id);
  }

  const show = (data) => {
    if (refDialogoShowSangria.current) {
      refDialogoShowSangria.current.handleOpen(data.id);
    }
  };

  const handleDeletar = (data) => {
    if (refDialogoDeletar.current) {
      refDialogoDeletar.current.handleOpen(data);
    }
  };

  useEffect(() => {
    if (ids && ids !== filterValues.visible) {
      switch (filterValues.visible) {
        case true:
          setCancelados(ids);
          break;
        case false:
          setConfirmados(ids);
          break;
        default:
          break;
      }
    }
  }, [ids, filterValues.visible]);

  const handleChange = useCallback(
    (event, value) => {
      if (setFilters) {
        setFilters(
          { ...filterValues, visible: value === 'nao_conferido' },
          displayedFilters,
        );
      }
    },
    [displayedFilters, filterValues, setFilters],
  );

  function handleClose() {
    refresh();
  }

  function handleLixeira(data) {
    if (refDialogoLixeira.current) {
      refDialogoLixeira.current.handleOpen(data.id);
    }
  }

  const { enqueueSnackbar } = useSnackbar();

  async function imprimir(id) {
    if (id > 0) {
      const codigo = await imprimirTroco(id);
      if (codigo < 0) {
        enqueueSnackbar('Erro ao imprimir a nota!', {
          variant: 'error',
        });
      }
    }
  }

  return (
    <>
      <Title title="Sangrias" />
      <ListToolbar
        filters={props.filters}
        actions={<ActionsList {...props} />}
        {...props}
      />
      <Card style={{ borderRadius: '20px' }} {...props}>
        <Divider />
        <Tabs
          variant="fullWidth"
          centered
          value={filterValues.visible ? tabs[0].id : tabs[1].id}
          indicatorColor="primary"
          onChange={handleChange}
        >
          {tabs.map((choice) => (
            <Tab key={choice.id} label={choice.name} value={choice.id} />
          ))}
        </Tabs>
        <Divider />
        <div>
          {filterValues.visible === true && (
            <ListContextProvider value={{ ...listContext, ids: cancelados }}>
              <Datagrid>
                <StatusField
                  source="codigo"
                  label=""
                  headerClassName={classes.dataHeader}
                  cellClassName={classes.dataCell}
                  sortable={false}
                />
                <CodigoField
                  source="codigo"
                  label="Código"
                  headerClassName={classes.dataHeader}
                  cellClassName={classes.dataCell}
                  sortable={false}
                />
                <DateField
                  source="data_pagamento"
                  label="Horário"
                  headerClassName={classes.dataHeader}
                  cellClassName={classes.dataCell}
                  options={{ hour: 'numeric', minute: 'numeric' }}
                  sortable={false}
                />
                <TextField
                  source="sessao_id"
                  label="Sessão"
                  headerClassName={classes.dataHeader}
                  cellClassName={classes.dataCell}
                  sortable={false}
                />
                <ContaField
                  label="Caixa"
                  source="conta_id"
                  sortable={false}
                  headerClassName={classes.dataHeader}
                  cellClassName={classes.categoriaCell}
                />
                <Textofield
                  label="Frentista"
                  source="sessao.user.username"
                  sortable={false}
                  headerClassName={classes.dataHeader}
                  cellClassName={classes.categoriaCell}
                />
                <Textofield
                  label="Responsável"
                  source="responsavel.username"
                  sortable={false}
                  headerClassName={classes.dataHeader}
                  cellClassName={classes.categoriaCell}
                />
                <Textofield
                  label="Transportador"
                  source="transportador1.username"
                  sortable={false}
                  headerClassName={classes.dataHeader}
                  cellClassName={classes.categoriaCell}
                />
                <ValorTransferenciaField
                  source="valor"
                  textAlign="right"
                  label="Valor"
                  headerClassName={classes.dataHeader}
                  cellClassName={classes.valorCell}
                  sortable={false}
                />
                <ActionsField
                  source="lalala"
                  /* handleEfetivar={changeStatus}
                  handleShow={show}
                  handleDeletar={handleDeletar} */
                  textAlign="right"
                  label="Ações"
                  headerClassName={classes.dataHeader}
                  cellClassName={classes.actionsCell}
                  sortable={false}
                  //handleLixeira={handleLixeira}
                  actions={[
                    {
                      title: 'Efetivar',
                      icon: ({ record }) =>
                        !record.status ? (
                          <CheckCircleOutlineIcon />
                        ) : (
                          <CancelIcon />
                        ),
                      show: (record) => !!record.visible,
                      disabled: () => false,
                      onClick: (record) => changeStatus(record),
                    },
                    {
                      title: 'Detalhes',
                      icon: <DetailsIcon />,
                      show: () => true,
                      disabled: () => false,
                      onClick: (record) => show(record),
                    },
                    {
                      title: 'Imprimir',
                      icon: <PrintIcon />,
                      show: () => true,
                      disabled: () => false,
                      onClick: (record) => imprimir(record?.id || -1),
                    },
                    {
                      title: 'Excluir',
                      icon: <DeleteOutlineIcon />,
                      show: (record) => !!record.visible,
                      disabled: () => false,
                      onClick: (record) => handleDeletar(record),
                    },
                    {
                      title: 'Mandar para a lixeira',
                      icon: <DeleteForeverIcon />,
                      show: (record) => !!record.visible,
                      disabled: () => false,
                      onClick: (record) => handleLixeira(record),
                    },
                  ]}
                />
              </Datagrid>
            </ListContextProvider>
          )}
          {filterValues.visible === false && (
            <ListContextProvider value={{ ...listContext, ids: confirmados }}>
              <Datagrid>
                <CodigoField
                  source="codigo"
                  label="Código"
                  headerClassName={classes.dataHeader}
                  cellClassName={classes.dataCell}
                  sortable={false}
                />
                <DateField
                  source="data_pagamento"
                  label="Horário"
                  headerClassName={classes.dataHeader}
                  cellClassName={classes.dataCell}
                  options={{ hour: 'numeric', minute: 'numeric' }}
                  sortable={false}
                />
                <TextField
                  source="sessao_id"
                  label="Sessão"
                  headerClassName={classes.dataHeader}
                  cellClassName={classes.dataCell}
                  sortable={false}
                />
                <ContaField
                  label="Caixa"
                  source="conta_id"
                  sortable={false}
                  headerClassName={classes.dataHeader}
                  cellClassName={classes.categoriaCell}
                />
                <Textofield
                  label="Frentista"
                  source="sessao.user.username"
                  sortable={false}
                  headerClassName={classes.dataHeader}
                  cellClassName={classes.categoriaCell}
                />
                <Textofield
                  label="Responsável"
                  source="responsavel.username"
                  sortable={false}
                  headerClassName={classes.dataHeader}
                  cellClassName={classes.categoriaCell}
                />
                <Textofield
                  label="Transportador"
                  source="transportador1.username"
                  sortable={false}
                  headerClassName={classes.dataHeader}
                  cellClassName={classes.categoriaCell}
                />
                <ValorTransferenciaField
                  source="valor"
                  textAlign="right"
                  label="Valor"
                  headerClassName={classes.dataHeader}
                  cellClassName={classes.valorCell}
                  sortable={false}
                />
                <ActionsField
                  source="lalala"
                  handleShow={show}
                  textAlign="right"
                  label="Ações"
                  headerClassName={classes.dataHeader}
                  cellClassName={classes.actionsCell}
                  sortable={false}
                  actions={[
                    {
                      title: 'Efetivar',
                      icon: ({ record }) =>
                        !record.status ? (
                          <CheckCircleOutlineIcon />
                        ) : (
                          <CancelIcon />
                        ),
                      show: (record) => !!record.visible,
                      disabled: () => false,
                      onClick: (record) => changeStatus(record),
                    },
                    {
                      title: 'Detalhes',
                      icon: <DetailsIcon />,
                      show: () => true,
                      disabled: () => false,
                      onClick: (record) => show(record),
                    },
                    {
                      title: 'Imprimir',
                      icon: <PrintIcon />,
                      show: () => true,
                      disabled: () => false,
                      onClick: (record) => imprimir(record?.id || -1),
                    },
                    {
                      title: 'Excluir',
                      icon: <DeleteOutlineIcon />,
                      show: (record) => !!record.visible,
                      disabled: () => false,
                      onClick: (record) => handleDeletar(record),
                    },
                    {
                      title: 'Mandar para a lixeira',
                      icon: <DeleteForeverIcon />,
                      show: (record) => !!record.visible,
                      disabled: () => false,
                      onClick: (record) => handleLixeira(record),
                    },
                  ]}
                />
              </Datagrid>
            </ListContextProvider>
          )}
        </div>
        <TransacoesPagination />
      </Card>
      <DialogoChangeStatus
        ref={refDialogoChangeStatus}
        handleClose={handleClose}
      />
      <DialogoDeletar ref={refDialogoDeletar} handleClose={handleClose} />
      <DialogoShowSangria ref={refDialogoShowSangria} />
      <DialogoLixeira ref={refDialogoLixeira} handleClose={handleClose} />
    </>
  );
};

const ContainerMyList = ({ children, ...props }) => (
  <>
    <ListBase {...props}>
      <MyList {...props} />
    </ListBase>
  </>
);

const TransacoesPagination = (props) => (
  <Pagination rowsPerPageOptions={[5, 10, 25, 50]} {...props} />
);

const List2 = (props) => (
  <ProtegerPagina permissao={PERMISSAO_TELA_SANGRIAS_LISTAR}>
    <ContainerMyList
      {...props}
      pagination={<TransacoesPagination />}
      perPage={50}
      filters={<Filter />}
      title="Sangrias"
      filterDefaultValues={{
        visible: true,
      }}
    />
  </ProtegerPagina>
);

export default List2;
